import { ref, computed } from 'vue'
import { useConfigStore } from '@/stores/config.js'
import { useYandexMapApiStore } from '@/stores/yandex-map-api.js'

export function useLoadYMapScript () {

    const configStore       = useConfigStore()
    const yMapApiStore      = useYandexMapApiStore()

    const mapLoader         = ref(true)
    const mapCrash          = ref(false)
    const mapReady          = ref(false)

    // Computed
    const isLoadYMapApi     = computed(() => yMapApiStore.isLoadScript)
    const yandexMapsSource  = computed(() => configStore.yandexMapsSource)

    if(!isLoadYMapApi.value) {

        // Загрузить yandex API
        const script = document.createElement('script')

        script.src = yandexMapsSource.value
        
        script.onload = async function () {
            // eslint-disable-next-line no-undef
            await ymaps3.ready

            // eslint-disable-next-line no-undef
            ymaps3.import.registerCdn(
                'https://cdn.jsdelivr.net/npm/{package}',
                '@yandex/ymaps3-default-ui-theme@latest'
            )

            yMapApiStore.setLoadScript()    

            mapLoader.value = false
        }

        script.onerror = async function () {
            mapLoader.value = true

            script.remove()
        
            mapLoader.value = false
            mapCrash.value  = true
            mapReady.value  = false
        }

        document.head.appendChild(script)
    } else {
        mapLoader.value = false
    }

    mapReady.value = true

    return {
        mapLoader,
        mapCrash,
        mapReady
    }
}